import useApiService from '../utilities/useApiService';
import { IPharmacyInfo } from '../network/models/PharmacyInterfaces';
import { QueryObserverResult, useQuery } from 'react-query';

export const usePharmacyInfo = (
   pharmacyId: string
): [
   IPharmacyInfo | undefined,
   (pharmacyId: string) => void,
   Omit<QueryObserverResult<any>, 'data' | 'refetch'>
] => {
   const { getMethod } = useApiService();

   const { data, refetch, ...state } = useQuery({
      queryKey: [`/pharmacies/${pharmacyId}/full`],
      queryFn: (context) =>
         getMethod<IPharmacyInfo | undefined>(
            `/pharmacies/${pharmacyId}/full`,
            { signal: context.signal }
         ),
      select: (response) => response?.data,
   });

   return [data, () => refetch({ cancelRefetch: true }), state];
};
